// Browser tab / history titles. Until 2026-09-23 every page kept index.html's static
// title, so Chrome history was a wall of identical "Family Car Buyers" entries and a
// deal you had open yesterday could not be found again by number (JR). The specific
// part goes FIRST: tabs and history rows truncate from the right.
//
// Labels match the sidebar (config/navigation.js) so a rep sees the same name in both.
// A function receives the route and returns the label, for pages that carry an id.

const BRAND = 'Family Car Buyers'

const TITLES = {
  dashboard: 'Dashboard',
  deals: 'Deals',
  'deal-detail': r => `Deal ${r.params.id}`,
  'deal-view': r => `Deal ${r.params.id}`,
  leads: 'Leads',
  conversations: 'Conversations',
  conversation: r => `Conversation ${r.params.id}`,
  'lead-detail': r => `Lead ${r.params.id}`,
  buyers: 'Buyer Directory',
  'auction-yards': 'Auction Yards',
  'schedule-pickup': 'Schedule Pickup',
  dispatch: 'Work Queue',
  'dispatch-detail': r => `Deal ${r.params.id} · Work Queue`,
  'title-queue': 'Title Team',
  'emailrv-queue': 'My Leads',
  'emailrv-lead': r => `Lead ${r.params.id} · My Leads`,
  'emailrv-requests': 'Supervisor Requests',
  'emailrv-reviews': 'My Reviews',
  'emailrv-distribution': 'Lead Distribution',
  'emailrv-waiting': 'Waiting on New Assignment',
  'emailrv-dashboard': 'Team Dashboard',
  'courtesy-assignment': 'Courtesy Assignment',
  'manager-queue': 'Manager Queue',
  'manager-queue-detail': r => `Deal ${r.params.id} · Manager Queue`,
  'agent-view': 'Agent View',
  'dispatch-admin-skill-matrix': 'Skill Matrix',
  'dispatch-admin-field-permissions': 'Field Permissions',
  'dispatch-admin-buckets': 'Buckets',
  'dispatch-admin-settings': 'Dispatch Settings',
  'dispatch-admin-work-time': 'Work Time Report',
  'dispatch-admin-productivity': 'Productivity Report',
  'hold-calculator': 'Hold/Red Calculator',
  'quote-calculator': 'Quote Calculator',
  'escalation-tool': 'Escalation Tool',
  'buyer-search': 'Buyer Search',
  'bulk-update': 'Bulk Update',
  'title-requirements': 'Title Requirements',
  'title-requirement-state': r => `${String(r.params.stateCode).toUpperCase()} Title Requirements`,
  'call-quality': 'Call Quality',
  'sales-bot-board': 'SalesBot Board',
  watchdog: 'Ads Watchdog',
  'conversion-review': 'Conversion Review',
  'sales-bot-settings': 'SalesBot Settings',
  'business-hours': 'Business Hours',
  'user-management': 'User Management',
  login: 'Sign In',
  signup: 'Sign Up',
  unauthorized: 'No Access',
  'not-found': 'Page Not Found',
}

// yearMakeModel is free text and RV rows run long ("2010 Keystone Springdale 266RLSSR-
// TRAVEL TRAILER - 26FT - ..."), so cut at the first spaced dash or comma (an unspaced
// one is part of the model: F-150) and keep four words: year, make, model, trim.
function shortVehicle(ymm) {
  const words = String(ymm || '').replace(/(\s-|-\s|\s–|,).*$/, '').trim().split(/\s+/).filter(Boolean)
  return words.slice(0, 4).join(' ')
}

// `vehicle` is passed by useDealPageTitle once the deal has loaded; it goes right after
// the id ("Deal 48976 · 2012 Honda Civic · Work Queue · Family Car Buyers").
export function pageTitleFor(route, vehicle) {
  const entry = TITLES[route.name]
  let label = typeof entry === 'function' ? entry(route) : entry
  if (!label) return `${BRAND} CRM`
  const v = shortVehicle(vehicle)
  if (v) label = label.replace(/^((?:Deal|Lead) \S+)/, `$1 · ${v}`)
  return `${label} · ${BRAND}`
}
